// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantIdentityCell-moduleavatar__szKs7";
var _2 = "RentalPortalApplicantIdentityCell-modulecontent__nE7WL";
var _3 = "RentalPortalApplicantIdentityCell-modulenameButton__aPt2Q";
var _4 = "RentalPortalApplicantIdentityCell-modulenameButtonText__AA9Ax";
var _5 = "RentalPortalApplicantIdentityCell-modulenewBadge__mjCTx";
export { _1 as "avatar", _2 as "content", _3 as "nameButton", _4 as "nameButtonText", _5 as "newBadge" }
